export default function getFilteredCropsWithinField(crops, field) {
  if (!crops?.length) return [];
  return crops
    ?.filter(crop =>
      (field?.cropzones || []).some(cropZone => cropZone.crop.id === crop.id)
    )
    .sort((a, b) => a.name.localeCompare(b.name));
}
